import {makeStyles} from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
    modal_container: {
        display: 'flex',
        minWidth: '400px',
        maxWidth: '460px',
        flexDirection: 'column',
        alignItems: 'stretch',
        justifyContent: 'center',
        backgroundColor: theme.palette.common.white,
        borderRadius: '4px',
        padding: '16px',
        border: `1px solid ${theme.palette.grey[200]}`,
    },
    hint: {
        wordBreak: 'break-word',
    },
    filter_container: {
        marginTop: '16px',
    },
    select_all_container: {
        display: 'flex',
        justifyContent: 'flex-end',
        marginTop: '12px',
    },
    select_all_checkbox: {
        padding: '4px 0',
        fontWeight: 'bold',
    },
    targets_container: {
        display: 'flex',
        flexDirection: 'column',
        gap: '4px',
        maxHeight: '300px',
        overflowY: 'auto',
        marginTop: '4px',
        border: `1px solid ${theme.palette.grey[200]}`,
        borderRadius: '4px',
        padding: '8px',
    },
    target_checkbox: {
        padding: '4px 0',
    },
    actions_container: {
        display: 'flex',
        justifyContent: 'flex-end',
        width: '100%',
        marginTop: '16px'
    },
    cancel_btn: {
        marginRight: '10px'
    },
    input: {
        marginTop: '0px'
    }
}));

export {useStyles}
